/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DimensionGroupingRule {
    getFixupPrototypeFunction() { return DimensionGroupingRule.fixupPrototype; }

    static newInstance(model: Partial<DimensionGroupingRule>): DimensionGroupingRule {
        let obj = Object.assign(new DimensionGroupingRule(), model);
        DimensionGroupingRule.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DimensionGroupingRule>): DimensionGroupingRule {
        if (!model) return null;
        return DimensionGroupingRule.newInstance(<DimensionGroupingRule> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DimensionGroupingRule) {
        if (!obj) return;

        models.DimensionGroupingRule.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DimensionGroupingRule): boolean {
        Object.setPrototypeOf(obj, DimensionGroupingRule.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.priority === undefined) {
            this.priority = 0;
        }
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
        if (this.platform_filters) {
            models.QueryOperator.fixupPrototype(this.platform_filters);
        }
        if (this.access_granted_identities) {
            models.AccessGrantedRolesAndUserGroups.fixupPrototype(this.access_granted_identities);
        }
        if (this.cost_anomaly_configuration) {
            models.GroupingRuleCostAnomalyConfiguration.fixupPrototype(this.cost_anomaly_configuration);
        }
        if (this.attributes) {
            for (let val of this.attributes) {
                models.AttributeValueBase.fixupPrototype(val);
            }
        }
        if (this.dependent_grouping_rule) {
            for (let val of this.dependent_grouping_rule) {
                models.DependentDimension.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of the Grouping Rule
     */
    name: string;

    /**
     * Grouping Rule Description
     */
    description: string;

    /**
     * ID of the Dimension grouping (system generated)
     */
    grouping_rule_id: string;

    /**
     * Type of Grouping Rule
     */
    rule_type: models.GroupingRuleType;

    attributes: Array<models.AttributeValueBase>;

    /**
     * Conditions applied to the grouping
     */
    filters: models.QueryOperator;

    /**
     * Platform the platform_filters apply to. Only applicable when platform_filters is set; unset means the platform_filters apply to all platforms
     */
    platform_type: models.Platforms;

    /**
     * Conditions applied to the grouping
     */
    platform_filters: models.QueryOperator;

    /**
     * Identities allowed to access this grouping rule
     */
    access_granted_identities: models.AccessGrantedRolesAndUserGroups;

    /**
     * Other Dimension Groupings associated with the grouping rule
     */
    dependent_grouping_rule: Array<models.DependentDimension>;

    /**
     * Cost Anomaly configuration for this grouping rule
     */
    cost_anomaly_configuration: models.GroupingRuleCostAnomalyConfiguration;

    /**
     * Priority of the Grouping Rule for evaluation order
     */
    priority: number;

}
